var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 64,
    viewBox: "0 0 127 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 3.3065 61.4767)",
    fill: "#B8BBD2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 18.4471 61.4767)",
    fill: "#B8BBD2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 33.5858 61.4767)",
    fill: "#B8BBD2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 48.7264 61.4767)",
    fill: "#B8BBD2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 63.8651 61.4767)",
    fill: "#B8BBD2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 79.0057 61.4767)",
    fill: "#B8BBD2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 94.1463 61.4767)",
    fill: "#B8BBD2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 109.285 61.4767)",
    fill: "#B8BBD2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 61.4767,
    r: 2.5233,
    transform: "rotate(-90 124.426 61.4767)",
    fill: "#B8BBD2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 3.3065 49.7013)",
    fill: "#B8BBD2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 18.4471 49.7013)",
    fill: "#B8BBD2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 33.5858 49.7013)",
    fill: "#B8BBD2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 48.7264 49.7013)",
    fill: "#B8BBD2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 63.8651 49.7013)",
    fill: "#B8BBD2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 79.0057 49.7013)",
    fill: "#B8BBD2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 94.1463 49.7013)",
    fill: "#B8BBD2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 109.285 49.7013)",
    fill: "#B8BBD2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 49.7013,
    r: 2.5233,
    transform: "rotate(-90 124.426 49.7013)",
    fill: "#B8BBD2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 3.3065 37.9259)",
    fill: "#B8BBD2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 18.4471 37.9259)",
    fill: "#B8BBD2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 33.5858 37.9259)",
    fill: "#B8BBD2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 48.7264 37.9259)",
    fill: "#B8BBD2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 63.8651 37.9259)",
    fill: "#B8BBD2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 79.0057 37.9259)",
    fill: "#B8BBD2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 94.1463 37.9259)",
    fill: "#B8BBD2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 109.285 37.9259)",
    fill: "#B8BBD2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 37.9259,
    r: 2.5233,
    transform: "rotate(-90 124.426 37.9259)",
    fill: "#B8BBD2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 3.3065 26.1505)",
    fill: "#B8BBD2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 18.4471 26.1505)",
    fill: "#B8BBD2"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 33.5858 26.1505)",
    fill: "#B8BBD2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 48.7264 26.1505)",
    fill: "#B8BBD2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 63.8651 26.1505)",
    fill: "#B8BBD2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 79.0057 26.1505)",
    fill: "#B8BBD2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 94.1463 26.1505)",
    fill: "#B8BBD2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 109.285 26.1505)",
    fill: "#B8BBD2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 26.1505,
    r: 2.5233,
    transform: "rotate(-90 124.426 26.1505)",
    fill: "#B8BBD2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 3.3065 14.3751)",
    fill: "#B8BBD2"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 18.4471 14.3751)",
    fill: "#B8BBD2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 33.5858 14.3751)",
    fill: "#B8BBD2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 48.7264 14.3751)",
    fill: "#B8BBD2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 63.8651 14.3751)",
    fill: "#B8BBD2"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 79.0057 14.3751)",
    fill: "#B8BBD2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 94.1463 14.3751)",
    fill: "#B8BBD2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 109.285 14.3751)",
    fill: "#B8BBD2"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 14.3751,
    r: 2.5233,
    transform: "rotate(-90 124.426 14.3751)",
    fill: "#B8BBD2"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.3065,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 3.3065 2.59975)",
    fill: "#B8BBD2"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4471,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 18.4471 2.59975)",
    fill: "#B8BBD2"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5858,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 33.5858 2.59975)",
    fill: "#B8BBD2"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.7264,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 48.7264 2.59975)",
    fill: "#B8BBD2"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8651,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 63.8651 2.59975)",
    fill: "#B8BBD2"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.0057,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 79.0057 2.59975)",
    fill: "#B8BBD2"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.1463,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 94.1463 2.59975)",
    fill: "#B8BBD2"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.285,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 109.285 2.59975)",
    fill: "#B8BBD2"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.426,
    cy: 2.59975,
    r: 2.5233,
    transform: "rotate(-90 124.426 2.59975)",
    fill: "#B8BBD2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSmall);
export default __webpack_public_path__ + "static/media/dots_small.87e937bb01902fe424ce0d93781bc184.svg";
export { ForwardRef as ReactComponent };